import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-history",
  templateUrl: "./med-icon-history.component.html",
})
export class MedIconHistoryComponent extends SvgMixinComponent {}
